import {
  DC_Domain_Models_Usages_UsageAggregation,
  DC_Domain_Models_Usages_UsageInterval,
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  ResponseModels_Usages_DynamicPricing_DynamicPricesResponse,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetDynamicPrices = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  accountId: number;
  start?: string;
  end?: string;
  interval?: DC_Domain_Models_Usages_UsageInterval;
  aggregation?: DC_Domain_Models_Usages_UsageAggregation;
};
/**
 * Get Dynamic Price List for all customers Products with dynamic pricing
 *
 * @returns ResponseModels_Usages_DynamicPricing_DynamicPricesResponse Success
 */
export function getDynamicPrices(
  { businessUnit, label, customerId, accountId, start, end, interval, aggregation }: GetDynamicPrices,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Usages_DynamicPricing_DynamicPricesResponse> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/dynamic/prices`,
      query: { start, end, interval, aggregation },
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}
